import {HttpCrudDataSource} from '../../../core/data-source/http-crud.data-source';
import {toJson} from '../../../core/data-source/json.mapper';
import {httpService} from '../../../core/services/http.service';
import {NotificationRuleRecord} from './notification-rule.record';

export class NotificationsCrudDataSource<T> extends HttpCrudDataSource<T> {
    protected apiPath: string = '/gt/gt-api/notifications';

    async updateNotifications(record: NotificationRuleRecord): Promise<NotificationRuleRecord> {
        return httpService
            .put(this.apiPath, JSON.stringify(toJson(record)), {
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then((response: any) => response);
    }
}
